import React, {useContext, useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from "../components/drawer";
import HeaderBar from "../components/header-bar";
import {DrawerContext} from "../contexts/drawer";
import {useIsSignedIn} from "../services/auth";
import Modal from './modal';


export default function PageLayout({children, pageTitle}) {
    const [open, setOpen] = useContext(DrawerContext);
    const isSignedIn = useIsSignedIn();

    useEffect(() => {
        isSignedIn()
    }, []);


    const classes = useStyles();

    return (
        <div className={classes.root}>
            <CssBaseline/>
            <HeaderBar open={open} setOpen={setOpen} title={pageTitle}/>
            <Drawer open={open} setOpen={setOpen}/>
            <main className={classes.content}>
                <div className={classes.toolbar}/>
                {children}
            </main>
            <Modal/>
        </div>
    );
}

const drawerWidth = 240;

const useStyles = makeStyles((theme) => {
    console.log(theme.mixins.toolbar);
    return {
        root: {
            display: 'flex',
        },
        title: {
            flexGrow: 1
        },
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        appBarShift: {
            marginLeft: drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        menuButton: {
            marginRight: 36,
        },
        hide: {
            display: 'none',
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
        },
        toolbar: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: theme.spacing(0, 1),
            ...theme.mixins.toolbar,
        },
    }
});
